module.exports = __webpack_public_path__ + "static/media/autokar3 (3).cce4a458.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/wynajem/autokar3 (3).jpg
// module id = 858
// module chunks = 0